import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { MESSAGE_CONTENT_TYPE_ATTRIBUTE, MessageContentType } from '@gem/utils';

import { TextRenderer } from 'APP/components/TextRenderer/TextRenderer';
import { QuotedSelectionHighlight } from 'APP/main/ChatView/Messages/Message/components/QuoteSelectionHighlight/QuotedSelectionHighlight';
import type { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

interface IE2eePayloadProps {
  message: ChatMessage;
  isView?: boolean;
}

export const E2eePayload: FC<IE2eePayloadProps> = observer(({ message, isView }) => {
  const { text } = message.renderPayload;
  const { t } = useTranslation();

  return (
    <>
      <div {...{ [MESSAGE_CONTENT_TYPE_ATTRIBUTE]: MessageContentType.Text }}>
        <QuotedSelectionHighlight
          originalText={text || t('secure_chat_message_unavailable')}
          highlightedText={message.highlightedText}
          groupId={message.payload.message.groupId}
          isView={isView}
        >
          <TextRenderer
            userMentions={message.payload.userMentions}
            hasBotCommands={message.payload.message.group.isBot}
            keyWords={message.payload.keyWords}
            groupId={message.payload.message.groupId}
          >
            {text || t('secure_chat_message_unavailable')}
          </TextRenderer>
        </QuotedSelectionHighlight>
      </div>
    </>
  );
});
